//菜单类型
export default function (state){
    let type = "";
    switch (state) {
        case 1:
            type = '目录';
            break;
        case 2:
            type = '菜单';
            break;
        case 3:
            type = '按钮';
            break;
    }
    return type;
}
